<span *ngIf="inputMetadata['totalEmptyMandatoryFields'] === 1">
  There is <b class="error-count">{{this.inputMetadata['totalEmptyMandatoryFields']}}</b> missing mandatory field
</span>
<span *ngIf="inputMetadata['totalEmptyMandatoryFields'] > 1">
  There are <b class="error-count">{{this.inputMetadata['totalEmptyMandatoryFields']}}</b> missing mandatory fields
</span>
